module.exports = __webpack_public_path__ + "img/ewm15.830a49e6.jpg";